export default __webpack_public_path__ + "static/media/MFA Benefits (2).d78b0b3c.webp";